/*! @pentacode/ui v0.1.0 */
import { t as e } from "./decorateMetadata-BhwOl-pv.js";
import { t } from "./decorate-DHgd5sZx.js";
import "./icon-DGn-d_zv.js";
import { c as n, l as r } from "./chunk.UEBQI7VV-cl3cPog2.js";
import { t as i } from "./chunk.PZAN6FPN-NvFrxejO.js";
import { n as a } from "./dropdown-BkLolH2b.js";
import { LitElement as o, css as s, html as c, nothing as l } from "lit";
import { customElement as u, property as d } from "lit/decorators.js";
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.Q5SV6XNO.js
var f = s`
  :host {
    --color: var(--wa-color-surface-border);
    --width: var(--wa-border-width-s);
    --spacing: var(--wa-space-m);
    --label-spacing: var(--wa-space-s);
    --label-offset: 0;
  }

  :host(:not([orientation='vertical'])) {
    display: block;
    border-top: solid var(--width) var(--color);
    margin: var(--spacing) 0;
  }

  :host([orientation='vertical']) {
    display: inline-block;
    height: 100%;
    border-inline-start: solid var(--width) var(--color);
    margin: 0 var(--spacing);
    min-block-size: 1lh;
  }

  /* With a label, the host's border gives way to two lines that flank the label */
  :host([with-label]) {
    align-items: center;
    gap: var(--label-spacing);
    border: none;
  }

  :host([with-label]:not([orientation='vertical'])) {
    display: flex;
  }

  :host([with-label][orientation='vertical']) {
    display: inline-flex;
    flex-direction: column;
  }

  :host([with-label])::before,
  :host([with-label])::after {
    content: '';
    flex: 1 1 0;
  }

  :host([with-label]:not([orientation='vertical']))::before,
  :host([with-label]:not([orientation='vertical']))::after {
    min-inline-size: 1em;
    border-top: solid var(--width) var(--color);
  }

  :host([with-label][orientation='vertical'])::before,
  :host([with-label][orientation='vertical'])::after {
    min-block-size: 1lh;
    border-inline-start: solid var(--width) var(--color);
  }

  :host([with-label][label-placement='start'])::before,
  :host([with-label][label-placement='end'])::after {
    flex: 0 0 var(--label-offset);
    min-inline-size: 0;
    min-block-size: 0;
  }

  :host(:not([with-label])) .label {
    display: none;
  }

  :host([with-label]) .label {
    display: inline-flex;
    align-items: center;
    gap: var(--wa-space-2xs);
    flex: 0 1 auto;
    color: var(--wa-color-text-quiet);
    font-size: var(--wa-font-size-s);
    line-height: var(--wa-line-height-condensed);
    text-align: center;
  }
`, p = class extends n {
	constructor() {
		super(...arguments), this.hasSlotController = new a(this, "[default]"), this.orientation = "horizontal", this.withLabel = !1, this.labelPlacement = "center";
	}
	connectedCallback() {
		super.connectedCallback(), this.setAttribute("role", "separator");
	}
	willUpdate(e) {
		this.withLabel = this.hasSlotController.test("[default]", "withLabel"), super.willUpdate(e);
	}
	handleVerticalChange() {
		this.setAttribute("aria-orientation", this.orientation);
	}
	handleSlotChange() {
		this.internals && (this.internals.ariaLabel = this.textContent?.trim() || null);
	}
	render() {
		return c`
      <div part="label" class="label">
        <slot @slotchange=${this.handleSlotChange}></slot>
      </div>
    `;
	}
};
p.css = f, r([d({ reflect: !0 })], p.prototype, "orientation", 2), r([d({
	attribute: "with-label",
	type: Boolean,
	reflect: !0
})], p.prototype, "withLabel", 2), r([d({
	attribute: "label-placement",
	reflect: !0
})], p.prototype, "labelPlacement", 2), r([i("orientation")], p.prototype, "handleVerticalChange", 1), p = r([u("wa-divider")], p);
//#endregion
//#region src/elements/table/table-header-menu.ts
var m = class extends o {
	constructor(...e) {
		super(...e), this.column = null, this.native = !1;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		let e = this.column;
		if (!e) return l;
		let t = !!e.sortable, n = e.pinnable !== !1, r = !this.native;
		if (!t && !n && !r) return l;
		let i = e.pinned === "left", a = e.pinned === "right";
		return c`<ptc-ui-dropdown
            placement="bottom-end"
            distance="4"
            @change=${(e) => e.stopPropagation()}
            @wa-select=${(e) => {
			this.dispatchEvent(new CustomEvent("menu-select", {
				detail: { value: e.detail.item.value },
				bubbles: !0,
				composed: !0
			}));
		}}
        >
            <button
                slot="trigger"
                class="header-menu-trigger"
                aria-label="Column options for ${e.headerName}"
                @pointerdown=${(e) => e.stopPropagation()}
            >
                <ptc-ui-icon name="icon.action.show-options:active"></ptc-ui-icon>
            </button>
            ${e.sortable ? c`
                      <wa-dropdown-item value="sort-asc">
                          <ptc-ui-icon slot="icon" name="icon.action.sort-ascending:active"></ptc-ui-icon>
                          Aufsteigend sortieren
                      </wa-dropdown-item>
                      <wa-dropdown-item value="sort-desc">
                          <ptc-ui-icon slot="icon" name="icon.action.sort-descending:active"></ptc-ui-icon>
                          Absteigend sortieren
                      </wa-dropdown-item>
                  ` : l}
            ${n ? c`${t ? c`<wa-divider></wa-divider>` : l}
                      <wa-dropdown-item value="pin-left">
                          <ptc-ui-icon slot="icon" name="icon.action.pin:active"></ptc-ui-icon>
                          ${i ? "Loslösen" : "Links anheften"}
                      </wa-dropdown-item>
                      <wa-dropdown-item value="pin-right">
                          <ptc-ui-icon
                              slot="icon"
                              name="icon.action.pin:active"
                              style="transform: scaleX(-1)"
                          ></ptc-ui-icon>
                          ${a ? "Loslösen" : "Rechts anheften"}
                      </wa-dropdown-item>` : l}
            ${r ? c`${t || n ? c`<wa-divider></wa-divider>` : l}
                      <wa-dropdown-item value="autosize">
                          <ptc-ui-icon slot="icon" name="icon.action.autosize-column:active"></ptc-ui-icon>
                          Spalte anpassen
                      </wa-dropdown-item>
                      <wa-dropdown-item value="autosize-all">
                          <ptc-ui-icon slot="icon" name="icon.action.autosize-all-columns:active"></ptc-ui-icon>
                          Alle Spalten anpassen
                      </wa-dropdown-item>` : l}
        </ptc-ui-dropdown>`;
	}
};
t([d({ attribute: !1 }), e("design:type", Object)], m.prototype, "column", void 0), t([d({ type: Boolean }), e("design:type", Object)], m.prototype, "native", void 0), m = t([u("ptc-ui-table-header-menu")], m);
//#endregion
export { m as t };

//# sourceMappingURL=table-header-menu-B4_tTcs9.js.map